import { JobsTabIcon } from 'assets/icons';
import { FC } from 'react';

const EmptyStateJobReview: FC = () => {
  return (
    <div className="flex h-full flex-col items-center justify-center py-16 px-4">
      <JobsTabIcon className="mb-4 h-10 w-10" />
      <div className="mb-2 text-center text-17px font-semibold text-primaryText">
        No jobs found for the selected status.
      </div>
    </div>
  );
};

export default EmptyStateJobReview;
